<!-- eslint-disable max-lines -->
<template>
    <div class="contract-manage">
        <Paper class="contract-manage-paper">
            <el-tabs
                class="contract-list-tab-pane"
                v-model="activeTabs">
                <!-- 责任制调整 -->
                <el-tab-pane
                    label="责任制调整"
                    name="theList"
                    ref="myPane"
                    v-loading="holePageLoading">
                    <list-layout-paper>
                        <template slot="header-search">
                            <search-box
                                ref="searchBox"
                                :search-key="config.name"
                                :fields="config.searchFields"
                                :showResetBtn="true"
                                @search-change="getListClass.searchList"
                            />
                        </template>
                        <template slot="header-button">
                            <lotsButton
                                v-has="authorityCode.add"
                                type="primary"
                                size="mini"
                                @click="addNew"
                                title="新增"
                                :disabled="isDisableAdd"
                            >
                                <span class="icon iconfont">&#xe66a;</span> 新增
                            </lotsButton>
                            <lotsButton
                                v-has="authorityCode.export"
                                type="primary"
                                size="mini"
                                @click="handleExport()"
                                title="导出">
                                导出
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="刷新"
                                @click="refresh"
                                plain>
                                <span class="icon iconfont icon-refresh"></span>
                            </lotsButton>
                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button
                                icon="iconfont icon-list_install"
                                type="primary"
                                size="mini"
                                :title="'列配置'"
                                @click="showColumnConfigDialog"
                                plain />
                            </el-tooltip>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                v-loading="getListClass.tableLoading"
                                :control="true"
                                :selection="config.selection"
                                :columns="config.columns"
                                :height="tableHeight"
                                :tableData="getListClass.totalData"
                                :actions="config.actions"
                                :allowRowClick="false"
                                :editDisableRule="editDisableRuleFun"
                                :key="allowSort"
                                @sort-change="handleSort"
                                @btn-event="actionClick">
                                <template v-slot:col-append="{ item, row, rIndex }">

                                    <!-- 常规查看状态 -->
                                    <!-- 单据编码 -->
                                    <span v-if="['billCode'].includes(item.prop)">
                                        <lotsButton
                                            @click="toDetailPage(row)" type="text" size="mini" :title="row[item.prop]">
                                            {{ row[item.prop] }}
                                        </lotsButton>
                                    </span>

                                    <!-- 数据类型、操作类型、审批状态、执行状态 -->
                                    <span v-if="['dataType','operationType', 'approvalStatus','execStatus'].includes(item.prop)">
                                        {{ changeKeyToValue(row, item.prop, item.optionsKey) }}
                                    </span>

                                    <!-- 导入文件 -->
                                    <!-- 当操作类型=2-偏差调整/3-数据导入/4-删除时，允许导入 -->
                                    <span v-if="['respDataManageFileDetailVos'].includes(item.prop) && [2, 3, 4].includes(+row.operationType)">
                                        <!-- 有数据的时候展示数据 -->
                                        <template v-if="row.importFileList && row.importFileList.length">
                                            <p v-for="(item, index) in row.importFileList" :key="item.id">
                                                <lotsButton
                                                    @click="downLoadFile(item)" type="text" size="mini" title="下载">
                                                    {{ item.fileName }}
                                                </lotsButton>

                                                <!-- （1）判断执行状态=进行中/已完成时，禁止删除；
                                                     （2）判断有关联审批流程，且流程状态不等于草稿/驳回/撤回/废弃时，禁止删除；
                                                     -->
                                                <lotsButton
                                                    @click="deleteFile(row, item, index, 'importFileList')"
                                                    v-if="[1, 5, 6, 7].includes(+row.approvalStatus) && [1].includes(+row.execStatus)"
                                                    v-has="authorityCode.delete" type="text" size="mini" title="删除">
                                                    删除
                                                </lotsButton>
                                            </p>
                                        </template>
                                        <!-- 没有数据展示上传按钮 -->
                                        <!-- 空值，且当操作类型=2-偏差调整/3-数据导入/4-删除时，显示上传入口 -->
                                        <template v-else>
                                            <lotsButton v-if="[2, 3, 4].includes(+row.operationType)" v-has="authorityCode.upload" type="text" size="mini" title="上传" @click="openImport(row, rIndex)">
                                                上传
                                            </lotsButton>
                                        </template>
                                    </span>

                                    <!-- 其他附件 -->
                                    <span v-if="['otherFile'].includes(item.prop)">
                                        <template v-if="row.otherFileList && row.otherFileList.length">
                                            <p v-for="(item, index) in row.otherFileList" :key="item.id">
                                                <lotsButton
                                                    @click="downLoadFile(item)" type="text" size="mini" title="下载">
                                                    {{ item.fileName }}
                                                </lotsButton>

                                                <!-- （1）判断执行状态=进行中/已完成时，禁止删除；
                                                     （2）判断有关联审批流程，且流程状态不等于草稿/驳回/撤回/废弃时，禁止删除； -->
                                                <lotsButton
                                                    @click="deleteFile(row, item, index, 'otherFileList')"
                                                    v-if="[1, 5, 6, 7].includes(+row.approvalStatus) && [1].includes(+row.execStatus)"
                                                    v-has="authorityCode.delete" type="text" size="mini" title="删除">
                                                    删除
                                                </lotsButton>
                                            </p>
                                        </template>
                                    </span>
                                </template>

                                <!-- 编辑状态 -->
                                <template v-slot:edit-col-append="{ item, row, rIndex }">
                                    <!-- 单据编码 -->
                                    <span v-if="['billCode'].includes(item.prop)">
                                        <lotsButton
                                            @click="toDetailPage(row)" type="text" size="mini" :title="row[item.prop]">
                                            {{ row[item.prop] }}
                                        </lotsButton>
                                    </span>

                                    <!-- 操作类型 -->
                                     <span v-if="['operationType'].includes(item.prop)">
                                        <lots-select :options="dictDatas[item.optionsKey]" @change="(v) => operaChange(v, row, rIndex)" v-model="row[item.prop]"></lots-select>
                                    </span>

                                    <!-- 数据类型 -->
                                    <span v-if="['dataType'].includes(item.prop)">
                                        <lots-select :options="dataTypeOpt" :disabled="!row.operationType" v-model="row['dataType']"></lots-select>
                                    </span>

                                    <!-- 审批状态、执行状态 -->
                                    <span v-if="['approvalStatus','execStatus'].includes(item.prop)">
                                        {{ changeKeyToValue(row, item.prop, item.optionsKey) }}
                                    </span>

                                    <!-- 导入文件 -->
                                    <!-- 当操作类型=2-偏差调整/3-数据导入/4-删除时，允许导入 -->
                                    <span v-if="['respDataManageFileDetailVos'].includes(item.prop) && [2, 3, 4].includes(+row.operationType)">
                                        <!-- 有数据的时候展示数据 -->
                                        <template v-if="row.importFileList && row.importFileList.length">
                                            <p v-for="(item, index) in row.importFileList" :key="item.id">
                                                <lotsButton
                                                    @click="downLoadFile(item)" type="text" size="mini" title="下载">
                                                    {{ item.fileName }}
                                                </lotsButton>

                                                <!-- （1）判断执行状态=进行中/已完成时，禁止删除；
                                                     （2）判断有关联审批流程，且流程状态不等于草稿/驳回/撤回/废弃时，禁止删除； -->
                                                <lotsButton
                                                    @click="deleteFile(row, item, index, 'importFileList')"
                                                    v-if="[1, 5, 6, 7].includes(+row.approvalStatus) && [1].includes(+row.execStatus)"
                                                    v-has="authorityCode.delete" type="text" size="mini" title="删除">
                                                    删除
                                                </lotsButton>
                                            </p>
                                        </template>
                                        <!-- 没有数据展示上传按钮 -->
                                        <!-- 空值，且当操作类型=2-偏差调整/3-数据导入/4-删除时，显示上传入口 -->
                                        <template v-else>
                                            <lotsButton v-if="[2, 3, 4].includes(+row.operationType)"
                                            v-has="authorityCode.upload" type="text" size="mini" title="上传" @click="openImport(row, rIndex)">
                                                上传
                                            </lotsButton>
                                        </template>
                                    </span>

                                     <!-- 备注 -->
                                    <span v-if="['remark'].includes(item.prop)">
                                        <el-input
                                            type="textarea"
                                            :row="item.rows"
                                            :maxlength="500"
                                            placeholder="请输入"
                                            v-model="row[item.prop]">
                                        </el-input>
                                    </span>

                                    <!-- 数据月份 -->
                                    <span v-if="['dataMonth'].includes(item.prop)">
                                        <el-date-picker
                                            size="mini"
                                            v-model="row[item.prop]" :clearable="true"
                                            format="yyyy-MM" value-format="yyyy-MM" type="month"
                                            unlink-panels
                                            placeholder="选择日期"
                                            style="width: 130px;"
                                        >
                                        </el-date-picker>
                                    </span>

                                    <!-- 其他附件 -->
                                    <span v-if="['otherFile'].includes(item.prop)">
                                        <template v-if="row.otherFileList && row.otherFileList.length">
                                            <p v-for="(item, index) in row.otherFileList" :key="item.id">
                                                <lotsButton
                                                    @click="downLoadFile(item)" type="text" size="mini" title="下载">
                                                    {{ item.fileName }}
                                                </lotsButton>

                                                <!-- （1）判断执行状态=进行中/已完成时，禁止删除；
                                                     （2）判断有关联审批流程，且流程状态不等于草稿/驳回/撤回/废弃时，禁止删除； -->
                                                <lotsButton
                                                    @click="deleteFile(row, item, index, 'otherFileList')"
                                                    v-if="[1, 5, 6, 7].includes(+row.approvalStatus) && [1].includes(+row.execStatus)"
                                                    v-has="authorityCode.delete" type="text" size="mini" title="删除">
                                                    删除
                                                </lotsButton>
                                            </p>
                                        </template>
                                    </span>
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                @size-change="getListClass.sizeChange"
                                :current-page.sync="getListClass.pageNo"
                                @current-change="getListClass.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="getListClass.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
            </el-tabs>
            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.columns"
                ref="otpColumnConfig"
                @header-change="config.columns = $event"
            />

            <!-- 导入弹窗 -->
            <addFileDialog
                ref="fileDialogRef"
                :config="importConfig"
                @uploadSuccessHandle="uploadSuccessHandle"
            >
            </addFileDialog>
        </Paper>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getListApi, deleteApi, saveApi, getRowExportApi, getListExportApi, deleteFileApi, verityApi } from '@mdm/api/customer/customerPersonResponsibleDataApi.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import { ref, reactive, onMounted, computed, getCurrentInstance } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import utils from '@/components/utils/common.js';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import store from '@/store';
import _ from 'lodash';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
// import bigDataLog from '@/utils/bigDataLog.js';
import LotsSelect from '@/components/lots/lotsSelect/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import addFileDialog from './import.vue';
import { uploadConfig, uploadDeleteConfig } from './importConfig';

export default {
    name: 'customerPersonResponsibleData',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        editTableBox,
        lotsPagination,
        lotsButton,
        columnConfig,
        LotsSelect,
        addFileDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance();

        const dictDatas = ref({});
        onMounted(async() => {
            const dictKeys = [
                'LCRM_MIP_STATUS',
                'SYNC_BIG_DATA_STATUS',
                'RESP_DATA_FILE_TYPE', // 文件类型
                'REPORT_CRM_RESP_INCOME_SNAPSHOT', // CRM导出-责任制数据-收入定稿
                'REPORT_CRM_RESP_INCOME_HIS', // CRM导出-责任制数据-收入分摊
                'REPORT_CRM_RESP_GROSS_FEE_SNAPSHOT', // CRM导出-责任制数据-利润定稿
                'REPORT_CRM_RESP_GROSS_FEE_HIS', // CRM导出-责任制数据-利润分摊
                'REPORT_CRM_RESP_OVERDUE_SNAPSHOT', // CRM导出-责任制数据-应收定稿
                'REPORT_CRM_RESP_OVERDUE_HIS', // CRM导出-责任制数据-应收分摊
                'REPORT_CRM_RESP_INCOME', // CRM导出-责任制数据-收入
                'REPORT_CRM_RESP_GROSS', // CRM导出-责任制数据-利润
                'REPORT_CRM_RESP_OVERDUE' // CRM导出-责任制数据-应收
            ];
            dictDatas.value = await otherUtils.getDictDataList(config.columns, dictKeys);
            // console.log('dictDatas.value', dictDatas.value);
            setupContext.refs.searchBox.submitSearch();
        });

        // 列表类配置
        const config = reactive(configStatic);
        // 列表类-全局loading
        const holePageLoading = ref(false);
        // 列表列配置弹窗
        const otpColumnConfig = ref(null);
        // 列表列配置弹窗-打开
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        // 列表列配置弹窗-当前选中的tab
        const activeTabs = ref('theList');

        // 列表类
        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                // bigDataLog.sendDetailMessageByKey('bigData-btn-listPageSearch'); // 搜索埋点
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        v.edit = -3;
                        v.allowEdit = true;
                        v.operationType = v.operationType?.toString();
                        v.dataType = v.dataType?.toString();
                        v.execStatus = v.execStatus?.toString();
                        // 存在附件数据时，做分类处理，区分列表的上传文件，还是其他附件两个字段
                        v.importFileList = v.respDataManageFiles?.filter(item => item.fileType === '0') || [];
                        v.otherFileList = v.respDataManageFiles?.filter(item => item.fileType === '1') || [];
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }

        // 列表类-实例化
        const getListClass = new ListClass({
            Api: {
                listApi: getListApi
            }
        });

        // 列表类-查询参数格式化
        const searchDataFormat = (condition) => {
            if (condition.createTime && condition.createTime.length) {
                condition.startCreateTime = utils.formatDateTime(condition.createTime[0]);
                condition.endCreateTime = utils.formatDateTime(condition.createTime[1]);
                Reflect.deleteProperty(condition, 'createTime');
            }
            if (condition.updateTime && condition.updateTime.length) {
                condition.startUpdateTime = utils.formatDateTime(condition.updateTime[0]);
                condition.endUpdateTime = utils.formatDateTime(condition.updateTime[1]);
                Reflect.deleteProperty(condition, 'updateTime');
            }
            if (condition.selectList && condition.selectList.length) {
                condition.createUserCode = condition.selectList[0].userCode;
            }
            Reflect.deleteProperty(condition, 'selectList');
            Reflect.deleteProperty(condition, 'userCode');
            Reflect.deleteProperty(condition, 'userName');
            Object.keys(condition).forEach(k => {
                const v = condition[k];
                if (v === '' || v === null || (Array.isArray(v) && v.length === 0)) {
                    delete condition[k];
                }
            });
            return condition;
        };

        // 刷新列表
        const refresh = () => {
            getListClass.getList();
        };

        // 排序
        const allowSort = ref(true);
        const orderBy = ref('');
        const orderByType = ref('desc');
        const handleSort = ({ prop, order }) => {

        };

        // 操作类型改变时
        const dataTypeOpt = ref({});
        const operaChange = (v, row, isReset = true) => {
            // 操作类型改变时，根据操作类型，筛选数据类型选项
            const opt = {
                1: [2, 3, 4, 5, 6, 7, 8, 10],
                2: [3, 4, 6, 7, 9, 10],
                4: [3, 4, 6, 7, 9, 10]
            };
            const list = opt[v];
            const originalDataTypeOptions = dictDatas.value['SYNC_BIG_DATA_TYPE'] || {};

            // 创建新的选项对象，避免修改原始字典数据
            const filteredOptions = {};
            for (const key in originalDataTypeOptions) {
                if (list.includes(+key)) {
                    filteredOptions[key] = originalDataTypeOptions[key];
                }
            }
            dataTypeOpt.value = filteredOptions;
            // 重置数据操作
            if (isReset) {
                const arrList = _.cloneDeep(getListClass.totalData.value);
                arrList.map(item => {
                    // ids存在时，代表是新增的数据
                    if (item.ids) {
                        item.dataType = '';
                    }
                    // 存在id时，代表是已存在的编辑数据
                    if (item.id && (item.id === row.id)) {
                        item.dataType = '';
                    }
                });
                getListClass.totalData.value = arrList;
            }
        };

        // 字典值转换为字典标签
        const changeKeyToValue = (row, prop, optionsKey) => {
            return dictDatas.value[optionsKey]?.[row[prop]] ?? null;
        };

        // 按钮权限
        const authorityCode = reactive(btnAuthority.customerPersonResponsibleData);

        // 新增操作
        const addNew = () => {
            // 新增操作时，禁用排序
            allowSort.value = false;
            config.columns.map(item => {
                item.sort = false;
            });
            getListClass.totalData.value.unshift({
                ids: utils.uuid(), // ids主要是为了区分当前数据为新增数据
                saveRowLoading: false,
                enableLoading: false,
                disableLoading: false,
                edit: 2,
                allowEdit: true,
                approvalStatus: 1, // 只读，新增时默认草稿
                execStatus: null, // 只读，新增时默认空值
                importFileList: [],
                otherFileList: []
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };

        // 新增按钮是否禁用
        const isDisableAdd = computed(() => {
            return getListClass.totalData.value.some(item => item.edit === 2);
        });

        // 编辑按钮是否禁用
        const editDisableRuleFun = row => {
            // 草稿/驳回/撤回/废弃
            // return true;
            return ![1, 5, 6, 7].includes(+row.approvalStatus) || getListClass.totalData.value.some(item => item.edit === 2);
        };

        // 记录是第几条数据在进行上传操作
        const currFile = ref({});
        // 导入弹窗配置
        const importConfig = ref({});
        // 打开导入弹窗
        const openImport = (row, rIndex) => {
            currFile.value = row;
            // 后端接口参数必带数据类型
            if (row.dataType) {
                // 删除类型时需要更改模板下载请求接口
                if (+row.operationType === 4) {
                    importConfig.value = uploadDeleteConfig;
                } else {
                    importConfig.value = uploadConfig;
                    // 下载模板接口需要传数据类型字段
                    importConfig.value.downParams.dataType = row.dataType;
                    // 下载模板需要对应数据类型的文件名
                    const fileName = (dictDatas.value['SYNC_BIG_DATA_TYPE']?.[row['dataType']] ?? '') + '导入模板.xlsx';
                    importConfig.value.downParams.fileName = fileName;
                }
                setupContext.refs.fileDialogRef.openImport(row);
            } else {
                Message.warning('请先选择数据类型');
            }
        };

        // 上传附件成功
        const uploadSuccessHandle = (data) => {
            const list = _.cloneDeep(getListClass.totalData.value);
            // 找到当前上传文件所在的行索引
            const index = list.findIndex(o => o.id === currFile.value.id);
            list[index].importFileList.push({
                fileName: data.fileName,
                fileUrl: data.fileUrl,
                fileType: 0,
                id: null
            });
            getListClass.totalData.value = list;
        };

        // 列表单个数据操作点击事件
        const actionClick = (row, event, index) => {
            if (event === 'save') {
                saveOpera(row);
            }
            if (event === 'delete') {
                deleteOpera(row);
            }
            if (event === 'verity') {
                verityOpera(row);
            }
            if (event === 'export') {
                exportOpera(row);
            }
            if (event === 'cancel') {
                // 启用排序
                allowSort.value = true;
                config.columns.map(item => {
                    item.sort = true;
                });
            }
            // 编辑的时候需要回显对应的数据类型下拉
            if (event === 'edit') {
                operaChange(row.operationType, row, false);
            }
        };

        // 删除操作
        const deleteOpera = (row) => {
            MessageBox.confirm('此操作将删除记录,是否继续？', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getListClass.tableLoading.value = true;
                deleteApi(row.id).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        getListClass.getList();
                    }
                }).finally(() => {
                    getListClass.tableLoading.value = false;
                });
            });
        };

        // 删除文件，但目前需要用户点击保存才是实际删除
        const deleteFile = (row, item, index, src) => {
            if (item.relationId) {
                getListClass.tableLoading.value = true;
                deleteFileApi({ id: item.relationId }).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        row[src].splice(index, 1);
                        // getListClass.getList();
                    }
                }).finally(() => {
                    getListClass.tableLoading.value = false;
                });
            } else {
                row[src].splice(index, 1);
            }
        };

        // 审核操作
        // （1）当操作类型=1-系统跑数时，需要二次确认的弹框：系统跑数将覆盖对应月份数据，是否继续操作？
        // 点击确认后，触发系统跑数，完成后更新审批状态=审批通过，执行状态=已完成；
        // （2）当操作类型=2-偏差调整/4-删除时，跳转详情页；
        const verityOpera = (row) => {
            if (row.operationType === '1') {
                MessageBox.confirm('系统跑数将覆盖对应月份数据,是否继续操作？', '温馨提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const paras = {
                        id: row.id,
                        dataMonth: row.dataMonth,
                        dataType: +row.dataType,
                        operationType: +row.operationType
                    };
                    getListClass.tableLoading.value = true;
                    verityApi(paras).then(res => {
                        if (+res.code === 0) {
                            Message.success('审核提交成功');
                            getListClass.getList();
                        }
                    }).finally(() => {
                        getListClass.tableLoading.value = false;
                    });
                });
            }
            if (+row.operationType === 2 || +row.operationType === 4) {
                toDetailPage(row);
            }
        };

        // 跳转详情页
        const toDetailPage = (row) => {
            ctx.$router.push('/responsibleFlow?id=' + row.id);
        };

        // 下载文件
        const downLoadFile = (row) => {
            window.open(row.fileUrl);
        };

        // 导出列表信息
        const handleExport = () => {
            const excelTitleList = config.columns?.filter(item => (!item.hiddenColumn && item.prop !== 'execResult')).map(item => ({
                name: item.label,
                property: item.prop
            })) ?? [];
            const { value } = getListClass.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            // 配置了那些字段就传那些
            newData.excelTitleList = excelTitleList;
            getListExportApi(newData).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            });
        };

        // 列表单个数据导出操作
        const { user } = store.getters;
        const DATAOPT = {
            3: 'REPORT_CRM_RESP_INCOME_SNAPSHOT', // CRM导出-责任制数据-收入定稿
            4: 'REPORT_CRM_RESP_INCOME_HIS', // CRM导出-责任制数据-收入分摊
            6: 'REPORT_CRM_RESP_GROSS_FEE_SNAPSHOT', // CRM导出-责任制数据-利润定稿
            7: 'REPORT_CRM_RESP_GROSS_FEE_HIS', // CRM导出-责任制数据-利润分摊
            9: 'REPORT_CRM_RESP_OVERDUE_SNAPSHOT', // CRM导出-责任制数据-应收定稿
            10: 'REPORT_CRM_RESP_OVERDUE_HIS', // CRM导出-责任制数据-应收分摊
            2: 'REPORT_CRM_RESP_INCOME', // CRM导出-责任制数据-收入
            5: 'REPORT_CRM_RESP_GROSS', // CRM导出-责任制数据-利润
            8: 'REPORT_CRM_RESP_OVERDUE' // CRM导出-责任制数据-应收
        };
        const exportOpera = (row) => {
            const params = {
                userCode: user.userCode,
                periodMonth: row.dataMonth,
                ...dictDatas.value[DATAOPT[row.dataType]]
            };
            getRowExportApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            });
        };

        // 列表单个数据保存操作
        const saveOpera = (row) => {
            const rowData = _.cloneDeep(row);
            // console.log('获取的原始数据:', rowData);
            if (!rowData.dataMonth) {
                return Message.warning('数据月份不能为空。');
            }
            if (!rowData.dataType) {
                return Message.warning('数据类型不能为空。');
            }
            if (!rowData.operationType) {
                return Message.warning('操作类型不能为空。');
            }

            // （3）当操作类型=2-偏差调整/3-数据导入/4-删除时，校验导入文件必填
            if (rowData.operationType === '2' || rowData.operationType === '3' || rowData.operationType === '4') {
                if (!rowData.importFileList || rowData.importFileList.length === 0) {
                    return Message.warning('导入文件不能为空。');
                }
            }
            const params = {
                id: rowData.id,
                billCode: rowData.billCode,
                billTitle: rowData.billTitle,
                dataMonth: rowData.dataMonth,
                dataType: +rowData.dataType,
                operationType: +rowData.operationType,
                remark: rowData.remark,
                respDataManageFiles: []
            };
            // 将之前的上传附件合并回respDataManageFiles字段
            rowData.importFileList.forEach(item => {
                params.respDataManageFiles.push(item);
            });
            // 将之前的其他附件合并回respDataManageFiles字段
            rowData.otherFileList.forEach(item => {
                params.respDataManageFiles.push(item);
            });
            // console.log('提交的参数:', params);
            // 提交到后端
            getListClass.tableLoading.value = true;
            saveApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success(row.id ? '更新成功' : '新增成功');
                    getListClass.getList();
                }
            }).finally(() => {
                getListClass.tableLoading.value = false;
                // 启用排序
                allowSort.value = true;
                config.columns.map(item => {
                    item.sort = true;
                });
            });
        };

        return {
            getListClass,
            config,
            refresh,
            otpColumnConfig,
            showColumnConfigDialog,
            activeTabs,
            actionClick,
            holePageLoading,
            utils,
            authorityCode,
            addNew,
            handleExport,
            dictDatas,
            importConfig,
            openImport,
            editDisableRuleFun,
            changeKeyToValue,
            isDisableAdd,
            deleteFile,
            uploadSuccessHandle,
            handleSort,
            toDetailPage,
            downLoadFile,
            operaChange,
            dataTypeOpt,
            allowSort
        };
    }
};
</script>
<style lang="less">
.contract-manage {
    width: 100%;
    .contract-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }
    .contract-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;
        & > .el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;
            & > .el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;
                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }
    .list-header {
        .contract-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }
    .list-layout .list-header .el-input{
        margin-left: 0;
    }
    .layout-content.contract-manage-paper {
        padding: 0px 20px 20px;
        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}
.contract-manage-list-dropdown-menu {
    background-color: #fff;
}
.column-config_title {
    font-size: 14px;
}
</style>
